import { createContext, useContext, useState, useEffect } from 'react';

const THEME_KEY = 'fa_theme';

const ThemeContext = createContext(null);

function readStoredTheme() {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'cool') return stored;
  return 'cool';
}

/**
 * Provides the app's light/cool theme preference. Persists the choice to
 * localStorage and reflects it as a data-theme attribute on <html> for CSS to key off.
 */
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readStoredTheme);

  useEffect(() => {
    localStorage.setItem(THEME_KEY, theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  function toggleTheme() {
    setTheme(t => (t === 'light' ? 'cool' : 'light'));
  }

  const value = { theme, toggleTheme };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

/** Hook to access theme state. Must be used inside <ThemeProvider>. */
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}

export default ThemeContext;
